export const cryptoskillPaymentsAData = [
  {
    id: 'agenti',
    name: 'Agenti Payment Engine',
    author: 'Agenti Labs',
    authorHandle: '@agenti-labs',
    tag: 'Skill',
    category: 'other',
    description: 'Agent-native payment engine enabling autonomous crypto transactions, billing orchestration, and multi-currency settlement for AI agents.',
    downloads: 7820,
    stars: 312,
    version: '2.1.0',
    installCommand: 'npm install @agenti/payment-engine',
    usageExample: '> process agent payment\n> setup billing cycle\n> multi-currency settle',
    detailedDescription: 'Agenti provides a native payment engine designed for autonomous AI agents. Supports crypto transaction processing, billing cycle orchestration, subscription management, and multi-currency settlement with real-time exchange rate feeds.',
    featured: true,
  },
  {
    id: 'agentpay-sdk',
    name: 'AgentPay SDK',
    author: 'AgentPay Team',
    authorHandle: '@agentpay',
    tag: 'Skill',
    category: 'tools',
    description: 'SDK for embedding crypto payment capabilities into any AI agent. Support for USDC, ETH, and major stablecoins with one-click checkout flows.',
    downloads: 12450,
    stars: 487,
    version: '3.4.1',
    installCommand: 'npm install agentpay-sdk',
    usageExample: '> init agentpay client\n> create checkout session\n> process USDC payment',
    detailedDescription: 'AgentPay SDK enables any AI agent to accept crypto payments. Features one-click checkout, USDC/ETH/stablecoin support, webhook notifications, invoice generation, and merchant dashboard integration.',
    trending: true,
  },
  {
    id: 'agentshield-mcp',
    name: 'AgentShield MCP Payment Security',
    author: 'AgentShield',
    authorHandle: '@agentshield',
    tag: 'Skill',
    category: 'other',
    description: 'MCP-based payment security layer for AI agents. Fraud detection, transaction validation, and compliance checks for autonomous crypto payments.',
    downloads: 4560,
    stars: 189,
    version: '1.2.0',
    installCommand: 'npm install @agentshield/mcp-payments',
    usageExample: '> validate tx intent\n> run fraud check\n> approve payment route',
    detailedDescription: 'AgentShield MCP adds a security layer to agent payments via MCP protocol. Includes real-time fraud detection, transaction validation, KYC/AML compliance checks, and automated risk scoring before fund release.',
  },
  {
    id: 'aibtc-mcp-server',
    name: 'AI BTC MCP Server',
    author: 'AI BTC Labs',
    authorHandle: '@aibtc-labs',
    tag: 'Skill',
    category: 'tools',
    description: 'Bitcoin-native MCP server for AI agents. Lightning Network payments, on-chain BTC transactions, and wallet management.',
    downloads: 3890,
    stars: 156,
    version: '1.0.3',
    installCommand: 'npm install aibtc-mcp-server',
    usageExample: '> create BTC wallet\n> send lightning payment\n> check on-chain balance',
    detailedDescription: 'AI BTC MCP Server brings Bitcoin payment capabilities to AI agents via MCP. Supports Lightning Network micropayments, on-chain BTC transactions, wallet key management, and Taproot/SegWit address generation.',
  },
  {
    id: 'arcagent-commerce',
    name: 'ArcAgent Commerce',
    author: 'ArcAgent',
    authorHandle: '@arcagent',
    tag: 'Skill',
    category: 'other',
    description: 'E-commerce toolkit for AI agents. Product catalog management, cart orchestration, checkout flows, and order tracking with crypto settlement.',
    downloads: 6780,
    stars: 245,
    version: '2.0.1',
    installCommand: 'npm install arcagent-commerce',
    usageExample: '> add product to cart\n> process checkout\n> track order status',
    detailedDescription: 'ArcAgent Commerce provides a full e-commerce stack for AI agents including product catalog APIs, cart state management, multi-step checkout flows with crypto settlement, inventory tracking, and order fulfillment webhooks.',
    featured: true,
  },
  {
    id: 'arcpay-agent',
    name: 'ArcPay Agent',
    author: 'ArcPay',
    authorHandle: '@arcpay',
    tag: 'Skill',
    category: 'other',
    description: 'Payment agent for ArcPay network. Peer-to-peer crypto transfers, escrow creation, and dispute resolution for AI-mediated transactions.',
    downloads: 5210,
    stars: 198,
    version: '1.5.0',
    installCommand: 'npm install arcpay-agent',
    usageExample: '> create escrow\n> send p2p payment\n> resolve dispute',
    detailedDescription: 'ArcPay Agent enables peer-to-peer crypto payments with built-in escrow. Features multi-sig escrow creation, automated dispute resolution, payment scheduling, and integration with major EVM chains.',
  },
  {
    id: 'circle-official-bridge-stablecoin',
    name: 'Circle Bridge Stablecoin',
    author: 'Circle',
    authorHandle: '@circle',
    tag: 'Skill',
    category: 'defi',
    description: 'Official Circle cross-chain bridge for USDC. Transfer stablecoins across 15+ chains with CCTP integration and instant settlement.',
    downloads: 25600,
    stars: 892,
    version: '4.2.0',
    installCommand: 'npm install @circle/bridge-stablecoin',
    usageExample: '> bridge USDC to Polygon\n> check transfer status\n> estimate bridge fees',
    detailedDescription: 'Official Circle Cross-Chain Transfer Protocol (CCTP) integration for USDC. Enables trustless cross-chain USDC transfers across 15+ supported networks with instant finality, gas estimation, and transfer status tracking.',
    featured: true,
  },
  {
    id: 'circle-official-use-arc',
    name: 'Circle ARC Integration',
    author: 'Circle',
    authorHandle: '@circle',
    tag: 'Skill',
    category: 'tools',
    description: 'Programmable wallet toolkit with ARC. Deploy smart accounts, manage access control, and execute gasless transactions for AI agents.',
    downloads: 18900,
    stars: 654,
    version: '3.1.0',
    installCommand: 'npm install @circle/use-arc',
    usageExample: '> deploy smart account\n> set access policy\n> execute gasless tx',
    detailedDescription: 'Circle ARC (Account Recovery and Control) integration for programmable wallets. Supports smart account deployment, role-based access control, session key management, and gasless transaction sponsorship for AI agent operations.',
    trending: true,
  },
  {
    id: 'circle-official-use-circle-wallets',
    name: 'Circle Wallets',
    author: 'Circle',
    authorHandle: '@circle',
    tag: 'Skill',
    category: 'tools',
    description: 'Official Circle wallet infrastructure for developers. Custodial and non-custodial wallet creation, key management, and transaction signing.',
    downloads: 32100,
    stars: 1023,
    version: '5.0.0',
    installCommand: 'npm install @circle/wallets',
    usageExample: '> create wallet\n> sign transaction\n> manage keys',
    detailedDescription: 'Official Circle wallet SDK providing both custodial and non-custodial wallet solutions. Features key management, HSM-backed signing, multi-tenant wallet provisioning, and compliance-ready audit trails for institutional deployments.',
    featured: true,
  },
  {
    id: 'circle-official-use-developer-controlled-wallets',
    name: 'Circle Developer Wallets',
    author: 'Circle',
    authorHandle: '@circle',
    tag: 'Skill',
    category: 'tools',
    description: 'Developer-controlled wallets with full key custody. Server-side transaction signing, batch operations, and automated wallet provisioning.',
    downloads: 21500,
    stars: 745,
    version: '4.0.1',
    installCommand: 'npm install @circle/dev-wallets',
    usageExample: '> provision wallet\n> batch sign txs\n> rotate keys',
    detailedDescription: 'Developer-controlled wallet solution from Circle with full server-side key custody. Supports automated wallet provisioning, batch transaction signing, key rotation policies, and programmatic recovery flows for backend systems.',
  },
  {
    id: 'circle-official-use-gateway',
    name: 'Circle Payment Gateway',
    author: 'Circle',
    authorHandle: '@circle',
    tag: 'Skill',
    category: 'other',
    description: 'Enterprise-grade payment gateway for crypto and fiat. Multi-channel acceptance, risk scoring, and instant settlement to Circle wallets.',
    downloads: 28700,
    stars: 921,
    version: '3.5.0',
    installCommand: 'npm install @circle/gateway',
    usageExample: '> create payment intent\n> process card + crypto\n> settle to wallet',
    detailedDescription: 'Circle Payment Gateway provides enterprise-grade payment acceptance across crypto and fiat rails. Features multi-channel checkout, real-time risk scoring, instant settlement to Circle wallets, and comprehensive reconciliation reporting.',
    featured: true,
  },
  {
    id: 'circle-official-use-modular-wallets',
    name: 'Circle Modular Wallets',
    author: 'Circle',
    authorHandle: '@circle',
    tag: 'Skill',
    category: 'tools',
    description: 'Modular smart wallet architecture. Plug-and-play modules for social recovery, multi-sig, session keys, and custom access policies.',
    downloads: 16700,
    stars: 578,
    version: '2.8.0',
    installCommand: 'npm install @circle/modular-wallets',
    usageExample: '> configure modules\n> add social recovery\n> enable session keys',
    detailedDescription: 'Circle Modular Wallets offer a composable smart wallet architecture. Mix and match modules for social recovery, multi-signature authorization, session key delegation, spending limits, and custom access control policies.',
  },
  {
    id: 'circle-official-use-smart-contract-platform',
    name: 'Circle Smart Contract Platform',
    author: 'Circle',
    authorHandle: '@circle',
    tag: 'Skill',
    category: 'tools',
    description: 'Deploy and manage smart contracts with Circle infrastructure. Template library, audit integration, and automated deployment pipelines.',
    downloads: 19800,
    stars: 689,
    version: '2.2.0',
    installCommand: 'npm install @circle/scp',
    usageExample: '> deploy from template\n> run audit check\n> upgrade contract',
    detailedDescription: 'Circle Smart Contract Platform for streamlined contract deployment. Includes a curated template library, automated security audit integration, upgradeable proxy patterns, and CI/CD deployment pipelines across multiple chains.',
  },
  {
    id: 'circle-official-use-usdc',
    name: 'Circle USDC Toolkit',
    author: 'Circle',
    authorHandle: '@circle',
    tag: 'Skill',
    category: 'defi',
    description: 'Official USDC integration toolkit. Mint, burn, transfer, and track USDC with real-time attestation and compliance hooks.',
    downloads: 45200,
    stars: 1456,
    version: '6.0.0',
    installCommand: 'npm install @circle/usdc-toolkit',
    usageExample: '> mint USDC\n> transfer to wallet\n> check attestation',
    detailedDescription: 'Official Circle USDC toolkit for comprehensive stablecoin operations. Features mint/burn controls, multi-chain transfer tracking, real-time reserve attestation, compliance webhook integration, and treasury management dashboards.',
    featured: true,
    trending: true,
  },
  {
    id: 'circle-official-use-user-controlled-wallets',
    name: 'Circle User Wallets',
    author: 'Circle',
    authorHandle: '@circle',
    tag: 'Skill',
    category: 'tools',
    description: 'User-controlled wallet solution with PIN and biometric security. Self-custody with recovery options and seamless dApp integration.',
    downloads: 23400,
    stars: 812,
    version: '4.1.0',
    installCommand: 'npm install @circle/user-wallets',
    usageExample: '> create user wallet\n> set biometric auth\n> connect to dApp',
    detailedDescription: 'Circle User Wallets provide a self-custody solution with enhanced UX. Features PIN and biometric authentication, social recovery setup, dApp connection via WalletConnect, and embedded fiat on/off ramps for end users.',
  },
  {
    id: 'cmc-x402',
    name: 'CMC x402 Price Oracle',
    author: 'CoinMarketCap',
    authorHandle: '@cmc',
    tag: 'Skill',
    category: 'analytics',
    description: 'CoinMarketCap price data via x402 micropayments. Real-time crypto prices, market caps, and volume with per-request USDC billing.',
    downloads: 15600,
    stars: 534,
    version: '2.0.0',
    installCommand: 'npm install @cmc/x402-oracle',
    usageExample: '> get BTC price\n> query market cap\n> pay per request',
    detailedDescription: 'CoinMarketCap data access powered by x402 micropayments. Fetch real-time crypto prices, market capitalization, trading volume, and historical OHLCV data with transparent per-request USDC billing on Base.',
    trending: true,
  },
  {
    id: 'configure-x402',
    name: 'x402 Configuration Tool',
    author: 'x402 Foundation',
    authorHandle: '@x402',
    tag: 'Skill',
    category: 'tools',
    description: 'Configuration and setup utility for x402 payment infrastructure. Gateway setup, pricing rules, and billing dashboard management.',
    downloads: 8900,
    stars: 312,
    version: '1.5.0',
    installCommand: 'npm install configure-x402',
    usageExample: '> init gateway\n> set pricing rules\n> configure billing',
    detailedDescription: 'Configuration toolkit for x402 micropayment infrastructure. Simplifies gateway deployment, pricing rule definition, billing dashboard setup, webhook configuration, and analytics integration for content and API monetization.',
  },
  {
    id: 'cym-rewards',
    name: 'CYM Rewards Engine',
    author: 'CYM Protocol',
    authorHandle: '@cym-protocol',
    tag: 'Skill',
    category: 'other',
    description: 'Loyalty and rewards engine for crypto payments. Cashback distribution, points tokenization, and tiered reward programs with on-chain settlement.',
    downloads: 6780,
    stars: 267,
    version: '2.1.0',
    installCommand: 'npm install cym-rewards',
    usageExample: '> setup reward tier\n> distribute cashback\n> claim reward tokens',
    detailedDescription: 'CYM Rewards Engine powers crypto-native loyalty programs. Features automated cashback distribution, points tokenization as ERC-20/ERC-721, tiered reward program management, and on-chain settlement with gas-optimized batch claims.',
  },
  {
    id: 'deepblue-x402-api',
    name: 'DeepBlue x402 API',
    author: 'DeepBlue',
    authorHandle: '@deepblue',
    tag: 'Skill',
    category: 'tools',
    description: 'Ocean data and analytics API with x402 micropayments. Marine intelligence, shipping routes, and climate data on a per-query basis.',
    downloads: 2340,
    stars: 98,
    version: '1.0.0',
    installCommand: 'npm install @deepblue/x402-api',
    usageExample: '> query ocean data\n> get shipping route\n> pay per query',
    detailedDescription: 'DeepBlue x402 API provides oceanographic data and marine intelligence via micropayments. Access shipping route optimization, climate trend analysis, and real-time maritime analytics with per-query USDC billing.',
  },
  {
    id: 'defi-yields-x402',
    name: 'DeFi Yields x402',
    author: 'DeFi Yield Aggregator',
    authorHandle: '@defiyields',
    tag: 'Skill',
    category: 'defi',
    description: 'DeFi yield data and opportunity discovery via x402. APY tracking, vault comparison, and yield farming recommendations with per-request billing.',
    downloads: 11200,
    stars: 423,
    version: '2.3.0',
    installCommand: 'npm install @defiyields/x402',
    usageExample: '> scan best yields\n> compare vaults\n> pay per request',
    detailedDescription: 'DeFi Yields x402 provides yield farming intelligence via micropayments. Track real-time APYs across 50+ protocols, compare vault strategies, receive risk-adjusted recommendations, and execute simulations with per-request USDC billing.',
    trending: true,
  },
  {
    id: 'fiber-agent',
    name: 'Fiber Payment Agent',
    author: 'Fiber Network',
    authorHandle: '@fiber-network',
    tag: 'Skill',
    category: 'other',
    description: 'High-speed payment agent for Fiber Network. Sub-second settlement, low-latency routing, and cross-border remittance automation.',
    downloads: 8900,
    stars: 345,
    version: '1.8.0',
    installCommand: 'npm install fiber-payment-agent',
    usageExample: '> init fiber connection\n> send fast payment\n> track settlement',
    detailedDescription: 'Fiber Payment Agent leverages Fiber Network for ultra-fast crypto payments. Features sub-second settlement finality, intelligent low-latency routing, automated cross-border remittance, and real-time FX rate locking.',
  },
  {
    id: 'fiber-commerce-agent',
    name: 'Fiber Commerce Agent',
    author: 'Fiber Network',
    authorHandle: '@fiber-network',
    tag: 'Skill',
    category: 'other',
    description: 'Commerce-focused payment agent on Fiber Network. Checkout optimization, merchant onboarding, and instant settlement for e-commerce.',
    downloads: 5670,
    stars: 234,
    version: '1.4.0',
    installCommand: 'npm install fiber-commerce-agent',
    usageExample: '> onboard merchant\n> optimize checkout\n> settle instantly',
    detailedDescription: 'Fiber Commerce Agent tailors Fiber Network for e-commerce payments. Features one-click merchant onboarding, checkout flow optimization, instant settlement to merchant wallets, and automated reconciliation reporting.',
  },
  {
    id: 'flash-payment-system',
    name: 'Flash Payment System',
    author: 'Flash Protocol',
    authorHandle: '@flash-protocol',
    tag: 'Skill',
    category: 'other',
    description: 'Lightning-fast payment system for AI agents. Instant confirmation, batched settlements, and programmable payment schedules.',
    downloads: 12300,
    stars: 456,
    version: '3.0.0',
    installCommand: 'npm install flash-payment-system',
    usageExample: '> send instant payment\n> batch settlements\n> schedule recurring',
    detailedDescription: 'Flash Payment System delivers near-instant crypto payments for AI agents. Features sub-second confirmation, gas-optimized batched settlements, programmable recurring payment schedules, and multi-chain payment routing.',
    featured: true,
  },
  {
    id: 'goldrush-x402',
    name: 'GoldRush x402',
    author: 'GoldRush',
    authorHandle: '@goldrush',
    tag: 'Skill',
    category: 'analytics',
    description: 'Blockchain data API with x402 micropayments. Transaction history, wallet analytics, and token portfolio tracking per query.',
    downloads: 18700,
    stars: 678,
    version: '2.5.0',
    installCommand: 'npm install @goldrush/x402',
    usageExample: '> query tx history\n> analyze wallet\n> pay per query',
    detailedDescription: 'GoldRush x402 provides comprehensive blockchain data via micropayments. Query detailed transaction histories, wallet analytics, token portfolio tracking, and DeFi position monitoring with transparent per-request USDC billing.',
    trending: true,
  },
  {
    id: 'jake-superfluid-concierge',
    name: 'Jake Superfluid Concierge',
    author: 'Jake',
    authorHandle: '@jake-superfluid',
    tag: 'Skill',
    category: 'defi',
    description: 'Superfluid streaming payments concierge for AI agents. Real-time money streaming, salary automation, and subscription billing.',
    downloads: 9450,
    stars: 378,
    version: '2.0.0',
    installCommand: 'npm install jake-superfluid-concierge',
    usageExample: '> start money stream\n> automate salary\n> manage subscriptions',
    detailedDescription: 'Jake Superfluid Concierge brings real-time streaming payments to AI agents. Create continuous money streams for salaries, automate subscription billing with per-second granularity, and manage Superfluid CFA and IDA agreements.',
  },
  {
    id: 'magnetai-free-usdc-transfer-mcp',
    name: 'MagnetAI Free USDC Transfer',
    author: 'MagnetAI',
    authorHandle: '@magnetai',
    tag: 'Skill',
    category: 'other',
    description: 'Free USDC transfer MCP server for AI agents. Gasless transfers, faucet integration, and recipient address management.',
    downloads: 15600,
    stars: 567,
    version: '1.3.0',
    installCommand: 'npm install @magnetai/free-usdc-mcp',
    usageExample: '> send free USDC\n> manage recipients\n> check faucet balance',
    detailedDescription: 'MagnetAI Free USDC Transfer MCP enables gasless USDC transfers for AI agents. Integrates with paymaster services for gas sponsorship, manages recipient address books, and includes faucet top-up automation for funded transfers.',
    trending: true,
  },
  {
    id: 'molty-cash-agent',
    name: 'Molty Cash Agent',
    author: 'Molty',
    authorHandle: '@molty',
    tag: 'Skill',
    category: 'other',
    description: 'Cash management agent for Molty payment network. Liquidity pooling, instant swaps, and yield-earning custody solutions.',
    downloads: 4560,
    stars: 187,
    version: '1.2.0',
    installCommand: 'npm install molty-cash-agent',
    usageExample: '> pool liquidity\n> instant swap\n> earn yield',
    detailedDescription: 'Molty Cash Agent manages liquidity and yield within the Molty payment network. Features automated liquidity pooling, instant token swaps with best-price routing, and yield-earning custody with auto-compounding strategies.',
  },
  {
    id: 'molty-cash-payments',
    name: 'Molty Cash Payments',
    author: 'Molty',
    authorHandle: '@molty',
    tag: 'Skill',
    category: 'other',
    description: 'Cash-based payment system for Molty Network. QR code payments, NFC tap-to-pay, and merchant settlement with instant conversion.',
    downloads: 7890,
    stars: 312,
    version: '2.0.0',
    installCommand: 'npm install molty-cash-payments',
    usageExample: '> generate QR payment\n> NFC tap-to-pay\n> settle merchant',
    detailedDescription: 'Molty Cash Payments brings traditional cash-like convenience to crypto. Generate dynamic QR codes for payments, NFC tap-to-pay for physical transactions, and instant merchant settlement with automatic stablecoin conversion.',
  },
  {
    id: 'molty-cash',
    name: 'Molty Cash',
    author: 'Molty',
    authorHandle: '@molty',
    tag: 'Skill',
    category: 'other',
    description: 'Core cash management for Molty ecosystem. Wallet abstraction, balance tracking, and multi-currency cash positions.',
    downloads: 10200,
    stars: 398,
    version: '2.5.0',
    installCommand: 'npm install molty-cash',
    usageExample: '> check cash balance\n> manage positions\n> convert currency',
    detailedDescription: 'Molty Cash is the core cash layer for the Molty ecosystem. Provides wallet abstraction for multiple currencies, real-time balance tracking, automated cash position management, and instant currency conversion with rate locking.',
  },
  {
    id: 'molty-payments',
    name: 'Molty Payments',
    author: 'Molty',
    authorHandle: '@molty',
    tag: 'Skill',
    category: 'other',
    description: 'Comprehensive payment suite for Molty Network. Peer transfers, merchant checkout, invoicing, and payroll with multi-chain support.',
    downloads: 13400,
    stars: 512,
    version: '3.0.0',
    installCommand: 'npm install molty-payments',
    usageExample: '> send peer transfer\n> create invoice\n> process payroll',
    detailedDescription: 'Molty Payments is the comprehensive payment suite for the Molty Network. Supports peer-to-peer transfers, merchant checkout integration, invoice generation and tracking, automated payroll distribution, and multi-chain payment routing.',
    featured: true,
  },
  {
    id: 'moonpay-official-allium-onchain-data',
    name: 'MoonPay Allium Onchain Data',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'analytics',
    description: 'On-chain data analytics via MoonPay and Allium. Wallet clustering, transaction forensics, and address labeling for compliance.',
    downloads: 18900,
    stars: 623,
    version: '2.0.0',
    installCommand: 'npm install @moonpay/allium-data',
    usageExample: '> cluster wallets\n> trace transactions\n> label addresses',
    detailedDescription: 'MoonPay Allium Onchain Data provides enterprise-grade blockchain analytics. Features wallet clustering algorithms, transaction forensics tracing, automated address labeling for compliance, and real-time risk scoring for payment flows.',
  },
  {
    id: 'moonpay-official-allium-x402',
    name: 'MoonPay Allium x402',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'analytics',
    description: 'On-chain analytics via x402 micropayments. Per-query blockchain intelligence with MoonPay and Allium integration.',
    downloads: 11200,
    stars: 445,
    version: '1.5.0',
    installCommand: 'npm install @moonpay/allium-x402',
    usageExample: '> query on-chain data\n> get analytics\n> pay per request',
    detailedDescription: 'MoonPay Allium x402 combines blockchain analytics with micropayment access. Query wallet histories, transaction patterns, and risk indicators on a per-request basis with USDC billing, powered by Allium data infrastructure.',
    trending: true,
  },
  {
    id: 'moonpay-official-corbits-marketplace',
    name: 'MoonPay Corbits Marketplace',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'other',
    description: 'NFT and digital asset marketplace via MoonPay. Fiat-to-crypto onboarding, instant NFT purchase, and wallet creation for buyers.',
    downloads: 15600,
    stars: 534,
    version: '2.2.0',
    installCommand: 'npm install @moonpay/corbits-marketplace',
    usageExample: '> browse NFTs\n> buy with fiat\n> create wallet',
    detailedDescription: 'MoonPay Corbits Marketplace simplifies NFT and digital asset purchases. Features fiat-to-crypto onboarding with credit card support, instant NFT purchase and transfer, embedded wallet creation for new buyers, and collection discovery tools.',
  },
  {
    id: 'moonpay-official-dune-analytics',
    name: 'MoonPay Dune Analytics',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Dune Analytics integration for MoonPay. Custom dashboard creation, SQL query execution, and payment flow visualization.',
    downloads: 13400,
    stars: 456,
    version: '1.8.0',
    installCommand: 'npm install @moonpay/dune-analytics',
    usageExample: '> create dashboard\n> run SQL query\n> visualize flows',
    detailedDescription: 'MoonPay Dune Analytics integration provides powerful on-chain data visualization. Create custom dashboards, execute SQL queries against Dune datasets, visualize payment flow patterns, and export reports for business intelligence.',
  },
  {
    id: 'moonpay-official-maiat-token-safety',
    name: 'MoonPay Maiat Token Safety',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'other',
    description: 'Token safety scanner for MoonPay transactions. Honeypot detection, rug pull risk scoring, and contract audit summaries.',
    downloads: 21200,
    stars: 745,
    version: '2.0.0',
    installCommand: 'npm install @moonpay/maiat-token-safety',
    usageExample: '> scan token contract\n> check safety score\n> detect honeypot',
    detailedDescription: 'MoonPay Maiat Token Safety protects users from malicious tokens. Features automated honeypot detection, rug pull risk scoring algorithms, contract audit summary aggregation, and real-time safety alerts before transaction execution.',
    featured: true,
  },
  {
    id: 'moonpay-official-maiat-trust-check',
    name: 'MoonPay Maiat Trust Check',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'other',
    description: 'Trust verification system for MoonPay. Reputation scoring, social graph analysis, and trust network validation for counterparties.',
    downloads: 18700,
    stars: 678,
    version: '1.5.0',
    installCommand: 'npm install @moonpay/maiat-trust-check',
    usageExample: '> check trust score\n> analyze social graph\n> validate counterparty',
    detailedDescription: 'MoonPay Maiat Trust Check provides reputation and trust verification for crypto transactions. Analyzes counterparty reputation scores, social graph connections, historical transaction trust patterns, and network-level validation before payment execution.',
  },
  {
    id: 'moonpay-official-messari-alpha-scout',
    name: 'MoonPay Messari Alpha Scout',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Alpha discovery via Messari and MoonPay. Early project signals, token unlock tracking, and institutional flow monitoring.',
    downloads: 15600,
    stars: 567,
    version: '2.1.0',
    installCommand: 'npm install @moonpay/messari-alpha-scout',
    usageExample: '> scout alpha signals\n> track token unlocks\n> monitor flows',
    detailedDescription: 'MoonPay Messari Alpha Scout delivers institutional-grade alpha signals. Track early project momentum indicators, monitor token unlock schedules, analyze smart money flows, and receive real-time alerts on significant market movements.',
    trending: true,
  },
  {
    id: 'moonpay-official-messari-deep-research',
    name: 'MoonPay Messari Deep Research',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Deep research reports via MoonPay and Messari. Protocol analysis, sector overviews, and quarterly market reviews with citations.',
    downloads: 12300,
    stars: 445,
    version: '1.5.0',
    installCommand: 'npm install @moonpay/messari-research',
    usageExample: '> get protocol report\n> sector overview\n> quarterly review',
    detailedDescription: 'MoonPay Messari Deep Research provides comprehensive crypto market research. Access detailed protocol analysis, sector-wide overviews, quarterly market reviews, and cited research reports powered by Messari intelligence infrastructure.',
  },
  {
    id: 'moonpay-official-messari-funding-intel',
    name: 'MoonPay Messari Funding Intel',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Funding intelligence via MoonPay and Messari. VC deal flow tracking, grant discovery, and fundraising trend analysis.',
    downloads: 11200,
    stars: 412,
    version: '1.3.0',
    installCommand: 'npm install @moonpay/messari-funding',
    usageExample: '> track VC deals\n> discover grants\n> analyze trends',
    detailedDescription: 'MoonPay Messari Funding Intel tracks crypto funding activity. Monitor VC deal flow in real-time, discover active grant programs, analyze fundraising trends by sector and stage, and receive alerts on significant capital deployment events.',
  },
  {
    id: 'moonpay-official-messari-token-research',
    name: 'MoonPay Messari Token Research',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Token research via MoonPay and Messari. Tokenomics analysis, unlock schedules, and comparative valuation metrics.',
    downloads: 14500,
    stars: 534,
    version: '1.8.0',
    installCommand: 'npm install @moonpay/messari-tokens',
    usageExample: '> analyze tokenomics\n> check unlocks\n> compare valuation',
    detailedDescription: 'MoonPay Messari Token Research provides deep token analysis. Evaluate tokenomics models, track vesting and unlock schedules, compare valuation metrics across similar projects, and assess supply inflation impact on price dynamics.',
  },
  {
    id: 'moonpay-official-messari-x402',
    name: 'MoonPay Messari x402',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Messari analytics via x402 micropayments. Per-request research data, market metrics, and protocol intelligence with USDC billing.',
    downloads: 9800,
    stars: 378,
    version: '1.2.0',
    installCommand: 'npm install @moonpay/messari-x402',
    usageExample: '> request market data\n> get protocol intel\n> pay per request',
    detailedDescription: 'MoonPay Messari x402 provides Messari analytics on a per-request basis. Access market metrics, protocol intelligence, and research data with transparent USDC micropayments, ideal for cost-sensitive data consumption workflows.',
  },
  {
    id: 'moonpay-official-moonpay-auth',
    name: 'MoonPay Auth',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'tools',
    description: 'Authentication and identity layer for MoonPay integrations. KYC verification, session management, and compliance-ready identity.',
    downloads: 25600,
    stars: 834,
    version: '3.0.0',
    installCommand: 'npm install @moonpay/auth',
    usageExample: '> verify identity\n> manage session\n> check KYC status',
    detailedDescription: 'MoonPay Auth provides identity and authentication infrastructure. Features streamlined KYC verification flow, secure session management, compliance-ready identity attestation, and biometric authentication support for mobile integrations.',
    featured: true,
  },
  {
    id: 'moonpay-official-moonpay-block-explorer',
    name: 'MoonPay Block Explorer',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'analytics',
    description: 'Integrated block explorer for MoonPay transactions. Multi-chain tx lookup, confirmation tracking, and gas analysis.',
    downloads: 19800,
    stars: 645,
    version: '2.5.0',
    installCommand: 'npm install @moonpay/block-explorer',
    usageExample: '> lookup transaction\n> track confirmations\n> analyze gas usage',
    detailedDescription: 'MoonPay Block Explorer provides transaction visibility across chains. Lookup transactions by hash or address, track confirmation progress in real-time, analyze gas usage patterns, and export transaction histories for accounting.',
  },
  {
    id: 'moonpay-official-moonpay-buy-crypto',
    name: 'MoonPay Buy Crypto',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'other',
    description: 'Fiat-to-crypto onramp via MoonPay. Credit card, bank transfer, and Apple Pay support with instant crypto delivery.',
    downloads: 52400,
    stars: 1856,
    version: '5.0.0',
    installCommand: 'npm install @moonpay/buy-crypto',
    usageExample: '> buy BTC with card\n> bank transfer onramp\n> Apple Pay crypto',
    detailedDescription: 'MoonPay Buy Crypto is the leading fiat-to-crypto onramp. Support for credit/debit cards, bank transfers, Apple Pay, Google Pay, and SEPA with instant crypto delivery to any wallet address across 100+ countries.',
    featured: true,
    trending: true,
  },
  {
    id: 'moonpay-official-moonpay-check-wallet',
    name: 'MoonPay Check Wallet',
    author: 'MoonPay',
    authorHandle: '@moonpay',
    tag: 'Skill',
    category: 'tools',
    description: 'Wallet validation and health check for MoonPay. Address verification, balance validation, and transaction readiness assessment.',
    downloads: 16700,
    stars: 567,
    version: '2.0.0',
    installCommand: 'npm install @moonpay/check-wallet',
    usageExample: '> validate address\n> check balance\n> assess readiness',
    detailedDescription: 'MoonPay Check Wallet provides pre-transaction wallet validation. Verify address formats and ownership, validate sufficient balances for intended transfers, assess network readiness, and detect potential issues before payment execution.',
  },
];